// ABOUTME: Hook that measures an element's offset from the top of the document,
// ABOUTME: re-measuring on window resize and body layout changes (ResizeObserver).

import { useState, useEffect, useCallback } from 'react';

const useDocumentOffsetTop = (ref, fallback = 0) => {
    const [offset, setOffset] = useState(fallback);

    const measure = useCallback(() => {
        const element = ref.current;
        if (!element) return;
        setOffset(element.getBoundingClientRect().top + window.scrollY);
    }, [ref]);

    useEffect(() => {
        measure();

        window.addEventListener('resize', measure);

        let observer;
        if (typeof ResizeObserver !== 'undefined') {
            observer = new ResizeObserver(measure);
            observer.observe(document.body);
        }

        return () => {
            window.removeEventListener('resize', measure);
            if (observer) observer.disconnect();
        };
    }, [measure]);

    return offset;
};

export default useDocumentOffsetTop;
